import React from 'react';
import { useTranslation } from 'react-i18next';
import logo from '../../assets/images/alrabie_logo.png';
import { getStyles } from './styles';
import analysis1 from '../../assets/images/certifications/analysis1.jpg';
import analysis2 from '../../assets/images/certifications/analysis2.jpg';
import analysis3 from '../../assets/images/certifications/analysis3.jpg';
import analysis4 from '../../assets/images/certifications/analysis4.jpg';
import analysis5 from '../../assets/images/certifications/analysis5.jpg';
import iso1 from '../../assets/images/certifications/ISO9001.jpg';
import iso2 from '../../assets/images/certifications/OHSAS18001.jpg';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import { Button } from '@mui/material';

const AboutUs = () => {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === 'ar';
  const styles = getStyles(isRtl, logo);

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = '/files/privacy_policy.pdf'; // PDF file inside public/files
    link.download = 'privacy_policy.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div style={styles.aboutUs}>
      <div style={styles.sectionHeader}>
        <div style={styles.sectionHeaderBefore} />
        <h2 style={styles.sectionHeaderH2}>
          {t('aboutUs.subtitle').split('Calcium carbonate')[0]}
          <br />
          <span style={styles.sectionHeaderHighlight}>Calcium Carbonate</span>
        </h2>
      </div>

      <div style={{ ...styles.section, ...styles.aboutUsSection }}>
        <div style={styles.aboutUsContent}>
          <h1 style={{...styles.h2, color: 'rgb(154,74,32)',}}>{t('aboutUs.title')}</h1>
          <p style={{...styles.p, marginBottom: '2px', marginTop: '5px'}}>{t('aboutUs.description1')}</p>
          <p style={{...styles.p, marginBottom: '2px', marginTop: '5px'}}>{t('aboutUs.description2')}</p>
          <p style={{...styles.p, marginBottom: '2px', marginTop: '5px'}}>{t('aboutUs.description3')}</p>
          <p>
          <i style={{...styles.p, marginTop: '30px', fontWeight: '500'}}>"{t('aboutUs.description4')}"</i>
          <br/>
          <i style={{...styles.p, marginTop: '30px', fontWeight: '400'}}>{t('aboutUs.description5')}</i>
          </p>
        </div>
      </div>

      <div style={{ ...styles.section}}>
        <div style={styles.aboutUsContent}>
        <h4 style={{...styles.h2, color: 'rgb(154,74,32)',}}>{t('aboutUs.mission')}</h4>
          <p style={{...styles.p, marginBottom: '2px', marginTop: '5px'}}>{t('aboutUs.missionDesc')}</p>
          
          <h4 style={{...styles.h2, color: 'rgb(154,74,32)',}}>{t('aboutUs.vision')}</h4>
          <p style={{...styles.p, marginBottom: '2px', marginTop: '5px'}}>{t('aboutUs.viaionDesc')}</p>

        </div>


      </div>

      <div style={{ ...styles.section, ...styles.offeringsSection }}>
        <h2 style={{...styles.h2,  color: 'rgb(154,74,32)', }}>{t('aboutUs.whatWeOffer')}</h2>
        <p style={styles.p}>{t('aboutUs.offerDescription')}</p>
        <ol style={styles.ol}>
          <li style={styles.li}>{t('aboutUs.products.1')}</li>
          <li style={styles.li}>{t('aboutUs.products.2')}</li>
          <li style={styles.li}>{t('aboutUs.products.3')}</li>
          <li style={styles.li}>{t('aboutUs.products.4')}</li>
        </ol>
        <p style={styles.p}>{t('aboutUs.exportInfo')}</p>
      </div>

      <div style={{ ...styles.section, ...styles.whyUsSection }}>
        <h2 style={{...styles.h2,  color: 'rgb(154,74,32)', }}>{t('aboutUs.whyUs')}</h2>
        <p style={{...styles.p, marginBottom:'5px'}}>{t('aboutUs.whyUsIntro')}</p>
        <p style={{...styles.p, marginTop:'0px'}}>{t('aboutUs.whyUsIntro2')}</p>
        {/* <div style={styles.benefitsList}>
          <div style={styles.benefitItem}>
            <span style={styles.bullet}>•</span>
            <span style={styles.benefitItemSpan}>
              {t('aboutUs.benefits.1')}
            </span>
          </div>
          <div style={styles.benefitItem}>
            <span style={styles.bullet}>•</span>
            <span style={styles.benefitItemSpan}>
              {t('aboutUs.benefits.2')}
            </span>
          </div>
          <div style={styles.benefitItem}>
            <span style={styles.bullet}>•</span>
            <span style={styles.benefitItemSpan}>
              {t('aboutUs.benefits.3')}
            </span>
          </div>
          <div style={styles.benefitItem}>
            <span style={styles.bullet}>•</span>
            <span style={styles.benefitItemSpan}>
              {t('aboutUs.benefits.4')}
            </span>
          </div>
          <div style={styles.benefitItem}>
            <span style={styles.bullet}>•</span>
            <span style={styles.benefitItemSpan}>
              {t('aboutUs.benefits.5')}
            </span>
          </div>
          <div style={styles.benefitItem}>
            <span style={styles.bullet}>•</span>
            <span style={styles.benefitItemSpan}>
              {t('aboutUs.benefits.6')}
            </span>
          </div>
          <div style={styles.benefitItem}>
            <span style={styles.bullet}>•</span>
            <span style={styles.benefitItemSpan}>
              {t('aboutUs.benefits.7')}
            </span>
          </div>
          <div style={styles.benefitItem}>
            <span style={styles.bullet}>•</span>
            <span style={styles.benefitItemSpan}>
              {t('aboutUs.benefits.8')}
            </span>
          </div>
        </div> */}
        <div style={{width: '100%', textAlign: 'end', marginTop: '25px', }}>
          <Button variant='outlined' sx={{color: 'rgb(154,74,32)', borderColor: 'rgb(154,74,32)',}} onClick={handleDownload}>{isRtl ? 'سياسة الخصوصية':'Privacy Policy'} (pdf)</Button>
        </div>
      </div>
      
      <div>
        <h2
          style={{...styles.h2, color: 'rgb(154,74,32)', textAlign: 'center'}}
        >
          {isRtl ? 'الشهادات والتحليلات':'Certifications and TDS analysis'}
        </h2>
       
        <div
          style={{
            display: 'flex',
            gap: '40px',
            // justifyContent: 'space-around',
            marginTop: '30px',
            flexWrap: "wrap"
          }}
        >
          <PhotoProvider
            speed={() => 800}
            easing={(type) =>
              type === 2
                ? 'cubic-bezier(0.36, 0, 0.66, -0.56)'
                : 'cubic-bezier(0.34, 1.56, 0.64, 1)'
            }
          >
            <PhotoView src={analysis1} style={styles.card}>
              <div style={styles.card}>
                <img
                  src={analysis1}
                  style={{ ...styles.image, objectFit: 'cover' }}
                  alt=""
                  loading="lazy"
                />
                <p style={{margin: '8px 10px 8px', fontSize: '12px', textAlign:'center', color: '#4a4a4a'}}>Analysis Report</p>
              </div>
            </PhotoView>
            <PhotoView src={analysis2} style={styles.card}>
              <div style={styles.card}>
                <img
                  src={analysis2}
                  style={{ ...styles.image, objectFit: 'cover' }}
                  alt=""
                  loading="lazy"
                />
                <p style={{margin: '8px 10px 8px', fontSize: '12px', textAlign:'center', color: '#4a4a4a'}}>Analysis Report</p>

              </div>
            </PhotoView>
            <PhotoView src={analysis3} style={styles.card}>
              <div style={styles.card}>
                <img
                  src={analysis3}
                  style={{ ...styles.image, objectFit: 'cover' }}
                  alt=""
                  loading="lazy"
                />
                <p style={{margin: '8px 10px 8px', fontSize: '12px', textAlign:'center', color: '#4a4a4a'}}>Analysis Report</p>

              </div>
            </PhotoView>
            <PhotoView src={analysis4} style={styles.card}>
              <div style={styles.card}>
                <img
                  src={analysis4}
                  style={{ ...styles.image, objectFit: 'cover' }}
                  alt=""
                  loading="lazy"
                />
                <p style={{margin: '8px 10px 8px', fontSize: '12px', textAlign:'center', color: '#4a4a4a'}}>Analysis Report</p>

              </div>
            </PhotoView>
            <PhotoView src={analysis5} style={styles.card}>
              <div style={styles.card}>
                <img
                  src={analysis5}
                  style={{ ...styles.image, objectFit: 'cover' }}
                  alt=""
                  loading="lazy"
                />
                <p style={{margin: '8px 10px 8px', fontSize: '12px', textAlign:'center', color: '#4a4a4a'}}>Analysis Report</p>

              </div>
            </PhotoView>
          </PhotoProvider>
        </div>
        <div
          style={{
            display: 'flex',
            gap: '40px',
            // justifyContent: 'space-around',
            marginTop: '30px',
            // alignItems: 'center',
            // justifyContent: 'center'
          }}
        >
          <PhotoProvider
            speed={() => 800}
            easing={(type) =>
              type === 2
                ? 'cubic-bezier(0.36, 0, 0.66, -0.56)'
                : 'cubic-bezier(0.34, 1.56, 0.64, 1)'
            }
          >
            <PhotoView src={iso1} style={styles.card}>
              <div style={styles.card}>
                <img
                  src={iso1}
                  style={{ ...styles.image, objectFit: 'cover' }}
                  alt=""
                  loading="lazy"
                />
                <p style={{margin: '8px 10px 8px', fontSize: '12px', textAlign:'center', color: '#4a4a4a'}}>ISO 9001</p>

              </div>
            </PhotoView>
            <PhotoView src={iso2} style={styles.card}>
              <div style={styles.card}>
                <img
                  src={iso2}
                  style={{ ...styles.image, objectFit: 'cover' }}
                  alt=""
                  loading="lazy"
                />
                <p style={{margin: '8px 10px 8px', fontSize: '12px', textAlign:'center', color: '#4a4a4a'}}>OHSAS 18001</p>

              </div>
            </PhotoView>
          </PhotoProvider>

        </div>
        
      </div>
    </div>
  );
};

export default AboutUs;
